module.exports = __webpack_public_path__ + "purchase-round.f8c2f62a55127c241570.png";


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/img/purchase-round.png
// module id = ../../../../../src/img/purchase-round.png
// module chunks = styles